import { cloneDeep, isEmpty } from 'lodash';
import DiscountType from '@/constants/DiscountType';
import StoreInfoAction from '@/actions/storeInfo/storeInfoAction';

const isMemberPointRedeemValid = (orderVo) => {
  const { memberPoint, orderPromotions } = orderVo;

  if (isEmpty(orderPromotions)) return true;

  let redeemPoints = 0;
  for (let i = 0; i < orderPromotions.length; i += 1) {
    const { ruleVo, quantity, redeemPoint } = orderPromotions[i];
    const { mode } = ruleVo;
    if (mode === DiscountType.REDEEM) {
      redeemPoints += redeemPoint * quantity;
    }
  }

  if (memberPoint < redeemPoints) return false;

  return true;
};

const isSubmitPreorderTimeValid = async (webStoreVo, orderVo) => {
  const { preorderTime, serveType } = orderVo;
  const storeInfoRes = await StoreInfoAction.getStoreInfo(webStoreVo.uuid, '');
  if (storeInfoRes == null) {
    return false;
  }

  const newWebStoreVo = JSON.parse(JSON.stringify(webStoreVo));
  newWebStoreVo.preorderTimeMap = storeInfoRes.data.webStoreVo.preorderTimeMap;

  let isTimeValid = false;
  let disable = false;
  if (preorderTime !== '' && preorderTime !== null && preorderTime.length > 0) {
    if (serveType === 'TAKE_OUT' || serveType === 'PICK_UP') {
      let firstAvailableTime;
      if (
        storeInfoRes.data.webStoreVo.preorderTimeMap.SCHEDULE_TAKE_OUT
          .availableDates.length > 0
      ) {
        const key =
          storeInfoRes.data.webStoreVo.preorderTimeMap.SCHEDULE_TAKE_OUT
            .availableDates[0];
        if (
          storeInfoRes.data.webStoreVo.preorderTimeMap.SCHEDULE_TAKE_OUT
            .availableTimes[key].length > 0
        ) {
          [firstAvailableTime] =
            storeInfoRes.data.webStoreVo.preorderTimeMap.SCHEDULE_TAKE_OUT.availableTimes[
              key
            ];
        }
      }
      if (firstAvailableTime) {
        let timeInfos = [];
        Object.keys(
          storeInfoRes.data.webStoreVo.preorderTimeMap.SCHEDULE_TAKE_OUT
            .timeInfos
        ).forEach((key) => {
          const preorderDate = preorderTime.split('T')[0];
          const k = key.split('T')[0];
          if (preorderDate === k) {
            timeInfos =
              storeInfoRes.data.webStoreVo.preorderTimeMap.SCHEDULE_TAKE_OUT
                .timeInfos[key];
          }
        });
        const firstAvailableTimeDate = new Date(firstAvailableTime);
        const preorderTimeDate = new Date(preorderTime);
        if (preorderTimeDate >= firstAvailableTimeDate) {
          timeInfos.forEach((info: any) => {
            if (info.time === preorderTime && info.full) {
              disable = true;
            }
          });
          if (!disable) {
            isTimeValid = true;
          }
        }
      }
    } else if (serveType === 'DELIVERY') {
      let firstAvailableTime;
      if (
        storeInfoRes.data.webStoreVo.preorderTimeMap.DELIVERY.availableDates
          .length > 0
      ) {
        const key =
          storeInfoRes.data.webStoreVo.preorderTimeMap.DELIVERY
            .availableDates[0];
        if (
          storeInfoRes.data.webStoreVo.preorderTimeMap.DELIVERY.availableTimes[
            key
          ].length > 0
        ) {
          [firstAvailableTime] =
            storeInfoRes.data.webStoreVo.preorderTimeMap.DELIVERY.availableTimes[
              key
            ];
        }
      }
      if (firstAvailableTime) {
        let timeInfos = [];
        Object.keys(
          storeInfoRes.data.webStoreVo.preorderTimeMap.DELIVERY.timeInfos
        ).forEach((key) => {
          const preorderDate = preorderTime.split('T')[0];
          const k = key.split('T')[0];
          if (preorderDate === k) {
            timeInfos =
              storeInfoRes.data.webStoreVo.preorderTimeMap.DELIVERY.timeInfos[
                key
              ];
          }
        });
        const firstAvailableTimeDate = new Date(firstAvailableTime);
        const preorderTimeDate = new Date(preorderTime);
        if (preorderTimeDate >= firstAvailableTimeDate) {
          timeInfos.forEach((info: any) => {
            if (info.time === preorderTime && info.full) {
              disable = true;
            }
          });
          if (!disable) {
            isTimeValid = true;
          }
        }
      }
    }
  } else {
    isTimeValid = true;
  }

  return isTimeValid;
};

const CartSubmit = { isSubmitPreorderTimeValid, isMemberPointRedeemValid };

export default CartSubmit;
